import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const PlaylistsPage = ({ token }) => {
  const [playlists, setPlaylists] = useState([]);

  useEffect(() => {
    const fetchPlaylists = async () => {
      const response = await axios.get('https://www.googleapis.com/youtube/v3/playlists', {
        params: {
          part: 'snippet',
          mine: true,
          maxResults: 50,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setPlaylists(response.data.items);
    };

    fetchPlaylists();
  }, [token]);

  return (
    <div className="container">
      <h2 className="my-4">Your Saved Playlists</h2>
      <Link to="/channels" className="btn btn-secondary mb-4">Back to Channels</Link>
      <div className="row">
        {playlists.map((playlist) => (
          <div className="col-md-3 col-sm-6 mb-4" key={playlist.id}>
            <Link to={`/playlist/${playlist.id}`}>
              <div className="card">
                <img
                  src={playlist.snippet.thumbnails.high.url}
                  className="card-img-top"
                  alt={playlist.snippet.title}
                  style={{ width: '100%', height: 'auto', margin: '0 auto' }}
                />
                <div className="card-body">
                  <h5 className="card-title text-center">{playlist.snippet.title}</h5>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlaylistsPage;
